import {
  MDXEditor,
  MDXEditorMethods,
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  thematicBreakPlugin,
  markdownShortcutPlugin,
  toolbarPlugin,
  BoldItalicUnderlineToggles,
  InsertTable,
  tablePlugin,
  UndoRedo,
  BlockTypeSelect,
} from "@mdxeditor/editor";
import "@mdxeditor/editor/style.css";
import "./Markdown.css";
import { useEffect, useRef } from "react";
import { Colors } from "@/constants/Colors";

export const Markdown = ({
  value,
  onChange,
  onBlur,
  focus,
  editable = false,
  maxHeight,
  backgroundColor = Colors.bg,
}: {
  value: string;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  focus?: boolean;
  editable?: boolean;
  maxHeight?: number;
  backgroundColor?: string;
}) => {
  const ref = useRef<MDXEditorMethods>(null);

  useEffect(() => {
    if (focus) {
      ref.current?.focus();
    }
  }, [focus]);

  useEffect(() => {
    if (ref.current) {
      ref.current.setMarkdown(value);
    }
  }, []);

  return (
    <div
      className="markdown-viewer"
      style={{
        maxHeight: maxHeight ? `${maxHeight}px` : "100%",
        overflow: maxHeight ? "hidden" : undefined,
        backgroundColor: backgroundColor,
      }}
    >
      <MDXEditor
        ref={ref}
        markdown={value}
        onChange={onChange}
        onBlur={() => onBlur?.(ref.current?.getMarkdown() ?? "")}
        readOnly={!editable}
        plugins={[
          headingsPlugin(),
          listsPlugin(),
          quotePlugin(),
          thematicBreakPlugin(),
          markdownShortcutPlugin(),
          ...(editable
            ? [
                tablePlugin(),
                toolbarPlugin({
                  toolbarContents: () => (
                    <>
                      <UndoRedo />
                      <BlockTypeSelect />
                      <BoldItalicUnderlineToggles />
                      <InsertTable />
                    </>
                  ),
                  toolbarClassName: "toolbar",
                }),
              ]
            : []),
        ]}
      />
    </div>
  );
};
